module.exports = __webpack_public_path__ + "img/progress-dote_empty.ca6687ea.svg";